import { Routes, Route } from "react-router";
import { useSelector } from "react-redux";
import { HasPermission } from "Core/security";
import { Navigate } from "react-router-dom";

//Views
import ReportsMain from "Modules/reports/views/main";
import ReportsOverview from "Modules/reports/views/overview";
import ScheduledReports from "Modules/reports/.components/scheduledReports";
import ReportExportHistory from "Modules/reports/.components/reportExportHistory";
const RouterReports = (props) => {
    const user = useSelector(state => state.securityRedux.user);
    return (
        <>
            <Routes>
                {HasPermission(user, "rpt") && <Route path="list" element={<ReportsMain />} />}
                {HasPermission(user, "rpt") && <Route path="overview/:id" element={<ReportsOverview />} />}
                {HasPermission(user, "rpt") && <Route path="scheduled_reports" element={<ScheduledReports />} />}
                <Route path="exporthistory" element={<ReportExportHistory />} />
                <Route path="*" element={<Navigate to="/error" />} />
            </Routes>
        </>
    )
}
export default RouterReports;